import $ from 'jquery';
import * as AugmentationConst from '../const/AugmentationConst';
import settings from '../../config/settings';
import urlJoin from 'url-join';

export default class RedirectPreset {
  constructor() {
    this.container = $(`#${AugmentationConst.redirectPresetFrameContainerId}`).first();
    if (!this.container.length) {
      this.container = $(`<div id="${AugmentationConst.redirectPresetFrameContainerId}" />`).appendTo('body');
    }
  }

  loadPresetFrame() {
    this.frame = $(
      `<iframe class="vup-cookieFrame"
               style="display: none"
               src="${urlJoin(settings.frontendBaseURL, '/cookie-preset')}" />`
    ).appendTo(this.container)[0];
  }
}
